// extracted by mini-css-extract-plugin
module.exports = {"joinPage":"JoinPage_joinPage__35DjB","spin360":"JoinPage_spin360__1Jzbu"};